import 'core-js/stable';
import BATD from './batd.js';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.batd-spa').forEach((el) => (el.classList.contains('load') ? new BATD(el) : null));
});
